import { createSelector } from '@reduxjs/toolkit'
import { SpotType } from '@/models/cart'
import { licenseSlice } from '@/store/licenseSlice'
import { cartSlice } from '..'

export const vehiclePlateErrorSelector = createSelector(
  [
    licenseSlice.selectors.license,
    cartSlice.selectors.selectedElementReservation,
  ],
  (license, selectedElementReservation) => {
    if (
      license === null ||
      !license.bookingVehiclePlateRequired ||
      selectedElementReservation === null ||
      selectedElementReservation.spotType !== SpotType.PARKING
    ) {
      return null
    }

    if (
      !selectedElementReservation.vehiclePlate ||
      selectedElementReservation.vehiclePlate.trim().length === 0
    ) {
      return 'map.elementDetail.vehiclePlate.errors.required'
    }

    return null
  }
)
